import { Instance } from "mobx-state-tree"
import { TournamentStatsModelBase } from "./TournamentStatsModel.base"

/* The TypeScript type of an instance of TournamentStatsModel */
export interface TournamentStatsModelType extends Instance<typeof TournamentStatsModel.Type> {}

/* A graphql query fragment builders for TournamentStatsModel */
export { selectFromTournamentStats, tournamentStatsModelPrimitives, TournamentStatsModelSelector } from "./TournamentStatsModel.base"

/**
 * TournamentStatsModel
 */
export const TournamentStatsModel = TournamentStatsModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
